import * as i0 from "@angular/core";
var DriveDomCacheService = /** @class */ (function () {
    function DriveDomCacheService() {
    }
    DriveDomCacheService.ngInjectableDef = i0.defineInjectable({ factory: function DriveDomCacheService_Factory() { return new DriveDomCacheService(); }, token: DriveDomCacheService, providedIn: "root" });
    return DriveDomCacheService;
}());
export { DriveDomCacheService };
